import JobViewModel from '../../JobViewModel'
import { observer } from 'mobx-react'
import React from 'react'
import {
  Section,
  RequestedSupportingItem,
  DocumentSupportingItemInput,
} from '../../../../../Checklist'
import styles from './SupportingItemChecklist.sass'
import cx from 'classnames'
import Icon from '../../../../../../components/Icon'

interface SupportingItemChecklistProps {
  vm: JobViewModel
}

export const SupportingItemChecklist = observer(
  ({ vm }: SupportingItemChecklistProps) => {
    return (
      <div>
        {vm.documentsVM.supportingItems.map((section, key) => {
          return <SupportingItemSection key={key} section={section} />
        })}
      </div>
    )
  },
)

interface SupportingItemSectionProps {
  section: Section
}

const SupportingItemSection = observer(
  ({ section }: SupportingItemSectionProps) => {
    return (
      <div
        className={styles.section}
        data-test={`checklist-supporting-items-section-${section.name}`}
      >
        <div className={styles.sectionHeader}>
          {section.heading}
          <div className={styles.sectionHeaderSubtext}>
            ({`${section.completedCount}/${section.totalCount}`})
          </div>
        </div>
        <div className={styles.sectionList}>
          {section.requestedSupportingItems.map((item, index) => {
            return (
              <div
                key={index}
                data-test={`checklist-supporting-items-item-${item.name}`}
                className={styles.supportingItem}
              >
                <div
                  className={cx(styles.icon, getItemStyle(item))}
                  data-test={`checklist-supporting-items-item-${item.name}-completion-status`}
                >
                  {item.completed ? (
                    <Icon name="tick" />
                  ) : item.adHoc ? (
                    <Icon name="alert-avatar" />
                  ) : (
                    <Icon name="circle" />
                  )}
                </div>
                <div
                  data-test={`checklist-supporting-items-item-${item.name}-name`}
                  className={styles.name}
                >
                  {item.name}
                  {item.required && (
                    <span
                      data-test={`checklist-supporting-items-item-${item.name}-required`}
                      className={styles.required}
                    >
                      *
                    </span>
                  )}
                </div>
                <div
                  className={cx(styles.providedInfo, getItemStyle(item))}
                  data-test={`checklist-supporting-items-item-${item.name}-provided`}
                >
                  {formatProvidedText(item)}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  },
)

/**
 * Formats the "Provided" text based on the input type.
 *
 * @param item
 */
function formatProvidedText(item: RequestedSupportingItem): string {
  if (item.adHoc && !item.completed) {
    return 'Requested'
  }

  switch (true) {
    case item.input instanceof DocumentSupportingItemInput: {
      return `${item.input!.documents.length} provided`
    }
    default: {
      if (item.completed) {
        return 'Provided'
      }
      return 'Not provided'
    }
  }
}

function getItemStyle(item: RequestedSupportingItem) {
  return item.completed
    ? styles.provided
    : item.adHoc
      ? styles.requested
      : styles.notProvided
}
